<template>
    <time
        v-if="variant === 'only-release-date'"
        class="paragraph-secondary"
        :class="`blog-date ${className}`"
        :datetime="formattedDate.dateTime"
    >
        {{ formattedDate.release }}
    </time>

    <div
        v-else
        class="paragraph-secondary"
        :class="`article-blog-date ${className}`"
    >
        <div>
            {{ $t('__publish_date') }}
            <time :datetime="formattedDate.dateTime">{{ formattedDate.release }}</time>
        </div>

        <div v-if="formattedDate.update">
            {{ $t('__updating_date') }}
            <time :datetime="formattedDate.updateTime">{{ formattedDate.update }}</time>
        </div>
    </div>
</template>

<script>
import format from 'date-fns/format';
import { ru, enUS, de, es, pt } from 'date-fns/locale';
import ROUTES from '../../../router/routing';
import { getCurrentPathWithoutLang } from '../../../utils/getPageLang';

export default {
    name: 'BlogDate',
    props: {
        date: {
            type: String,
            required: true,
        },
        className: {
            type: String,
            required: false,
            default: '',
        },
        variant: {
            type: String,
            default: 'release-and-last-update-date',
            validator(value) {
                return ['only-release-date', 'release-and-last-update-date'].includes(value);
            },
        },
    },
    data() {
        return {
            dateLocale: { en: enUS, ru, de, es, pt },
        };
    },
    computed: {
        locale() {
            return this.$route.params.locale || 'en';
        },
        formattedDate() {
            const [day, month, year] = this.date.split('.');
            const release = `${year}-${month}-${day}`;

            if (this.variant === 'only-release-date') {
                return {
                    release: this.formatDate(Date.parse(release)),
                    dateTime: release,
                };
            }

            const path = getCurrentPathWithoutLang(this.$router.currentRoute);
            const article = Object.keys(ROUTES).find((route) => ROUTES[route].path === path);

            const update = ROUTES[article].sitemap.lastmod.split('T')[0];

            const releaseDate = Date.parse(release);
            const updateDate = Date.parse(update);

            if (releaseDate < updateDate) {
                return {
                    release: this.formatDate(releaseDate),
                    update: this.formatDate(updateDate),
                    dateTime: release,
                    updateTime: update,
                };
            }

            return {
                release: this.formatDate(releaseDate),
                dateTime: release,
            };
        },
    },
    methods: {
        formatDate(date) {
            return format(date, 'd MMMM yyyy', {
                locale: this.dateLocale[this.locale],
            });
        },
    },
};
</script>

<style lang="scss" src="./style.scss"></style>
